import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import CheckIcon from '@mui/icons-material/Check';
const Root = styled('span')(({ theme }) => ({
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '1em',
    height: '1em',
    borderRadius: '50%',
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText
}));
/** Accent circle with a check mark; sized by `fontSize` (e.g. `sx={{ fontSize: '1rem' }}`). */
export const VerifiedBadge = ({ title, sx }) => (_jsx(Root, { title: title, sx: sx, children: _jsx(CheckIcon, { sx: { fontSize: '0.65em' } }) }));
//# sourceMappingURL=verified-badge.js.map